module.exports = "<div class=\"spinner\"><i class=\"fa fa-circle-o-notch fa-spin\"></i></div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/spinner/spinner.pug
// module id = 255
// module chunks = 0